module.exports = __webpack_public_path__ + "img/fm-f-Path 47 Copy@3x.a45424a6.png";